<div class="done-main">
  <div class="w-700 m-auto h-body">
    <div class="flex-1 done-con">
      <ng-container *ngIf="isDoneIconString">
        <i
          class="done-icon"
          [ngClass]="[doneIcon, blinkIcon ? 'blink' : '']"
        ></i>
      </ng-container>
      <ng-container *ngIf="doneIconObject as iconObj">
        <div class="done-icon-combined">
          <i class="done-icon-outer" [ngClass]="iconObj.outer"></i>
          <i class="done-icon-inner" [ngClass]="iconObj.inner"></i>
        </div>
      </ng-container>
      <p class="done-title">{{ doneTitle }}</p>
      <p class="done-body">
        {{ doneBody }}
      </p>
      <p class="done-remaining-balance" *ngIf="displayRemainingBalance">
        Remaining Balance: {{ displayRemainingBalance }}
      </p>
      <div class="btns-cont" *ngIf="isReactNative || isWebLogin">
        <a class="backToHome" (click)="sendClose()">Back To Home</a>
        <a class="logout" (click)="sendLogout()">Logout</a>
      </div>

      <div *ngIf="!isReactNative && !isWebLogin" class="m-t-l d-flex gap-m">
        <a [href]="androidLinke">
          <img
            src="https://res.cloudinary.com/kitchry/image/upload/v1726847930/Images%20for%20app/p-s.png"
            class="download-img"
          />
        </a>
        <a [href]="iosLinke">
          <img
            src="https://res.cloudinary.com/kitchry/image/upload/v1726847930/Images%20for%20app/a-s.png"
            class="download-img"
          />
        </a>
      </div>
    </div>
  </div>
</div>
